'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { pusdtAgreementBunja } from '@flipster/features/src/flipster-earn/premium-usdt/state';
import { earnSunsetPhaseBunja } from '@flipster/features/src/flipster-earn/sunset/phase-bunja';
import { earnStatisticsBunja, earnSummaryBunja } from '@flipster/features/src/shared/earn/state';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { PusdtCurrency } from '@flipster/utils/constants/currency';
import { convertDate } from '@flipster/utils/datetime';
import { isEarnSunsetProductCurrency } from '@flipster/utils/earn-sunset';

import { ActiveAprCard } from './active-apr-card';
import { InactiveAprCard } from './inactive-apr-card';
import { LatestUpdate } from './latest-update';

export const YourEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const { earnStatisticsAtom } = useBunja(earnStatisticsBunja);
  const { pusdtTermAgreedAtom } = useBunja(pusdtAgreementBunja);
  const { isFlipsterEarnHiddenAtom } = useBunja(earnSunsetPhaseBunja);

  const earnSummary = useAtomValue(earnSummaryAtom);
  const earnStatistics = useAtomValue(earnStatisticsAtom);
  const pusdtTermAgreed = useAtomValue(pusdtTermAgreedAtom);
  const isFlipsterEarnHidden = useAtomValue(isFlipsterEarnHiddenAtom);

  const latestUpdate = convertDate(earnStatistics?.aprUpdatedAt);

  return (
    <section className={stack({ gap: 20 })}>
      <div className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
        <FormattedMessage id='Autogen_common.r251126.s_Your_earnings' />
      </div>
      <div className={stack({ gap: 10 })}>
        {earnSummary?.currencies.map((c) => {
          const currency = c.currency;
          if (isFlipsterEarnHidden && isEarnSunsetProductCurrency(currency)) return null;

          if (currency === PusdtCurrency && !pusdtTermAgreed) {
            return <InactiveAprCard key={currency} currency={currency} />;
          }
          return <ActiveAprCard key={currency} currency={currency} />;
        })}
      </div>
      <LatestUpdate date={latestUpdate} />
    </section>
  );
};

export default YourEarnAprSection;
